<h3 mat-dialog-title class="title">{{ data.translations.title }}</h3>

<mat-dialog-content>
    <txp-message *ngIf="warningMessage"
                 [type]="messageType.WARNING"
                 data-qa-label="AddDialogWarningMessage">
        {{ warningMessage }}
    </txp-message>
    <div class="content">
        <div class="list">
            <txp-item-list
                class="item-list"
                [header]="data.translations.listTitle"
                [enableSelection]="true"
                [filterText]="filterText"
                [enableMultiSelect]="true"
                [hasCount]="true"
                [data]="itemsList"
                [entitiesSelectedText]="entitiesSelectedText"
                [hasTypeColumn]="!!data.itemTypeField"
                [typeKey]="data.itemTypeField"
                [typeAlign]="data.typeAlign"
                [typeHeader]="data.typeHeaderLabel || 'Type'"
                (emitSelection)="onSelected($event)"
                [disabledList]="disabledItems"
                [disabledLabel]="disabledLabel"
                [enableHeaderSort]="data.enableHeaderSort"
                listKey="name">
                <mat-form-field itemListFilter class="type-filter" *ngIf="data.typeFilterOptions?.length">
                    <mat-label>{{ data.typeFilterLabel }}</mat-label>
                    <mat-select data-qa-label="TypeFilterSelect"
                                [value]="typeFilterValue"
                                (selectionChange)="onTypeFilterChange($event.value)">
                        <mat-option [value]="allTypesValue">{{ data.typeFilterAllLabel }}</mat-option>
                        <mat-option *ngFor="let option of data.typeFilterOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </txp-item-list>
        </div>
        <div class="actions">
            <i class="tce-icon-arrow-right arrow"></i>
            <txp-button [style]="buttonStyle.SECONDARY"
                        data-qa-label="AddSelectedButton"
                        (click)="addSelected()"
                        class="add-selected-button">
                {{ 'form.button.add' | translate }}
            </txp-button>
        </div>
        <div class="selected-list" [formGroup]="form">

            <mat-form-field *ngIf="data.groupName || data.editableName">
                <mat-label>{{data.translations.group}}</mat-label>
                <input matInput
                       required
                       [readonly]="!data.editableName"
                       formControlName="groupName">
              <mat-error>
                {{ 'form.error.required' | translate}}
              </mat-error>
            </mat-form-field>

            <div class="title">{{ data.translations.listTitle }}</div>
            <div class="items">
                <div *ngIf="!selectedItems.length" class="no-msg">
                    {{ noneSelectedMsg }}
                </div>
                <div *ngFor="let item of selectedItems" class="item">
                    <div class="name">
                    <div class="item-name">
                      {{item['name'] || item}}
                      <span *ngIf="item['typeIndicator']">
                        ({{ item['typeIndicator'] }})
                      </span>
                    </div>
                    <div class="item-type" *ngIf="selectedItemType(item) as itemType">
                        {{ itemType }}
                    </div>
                    <div class="item-sku"
                         title="{{item['skuNumber']}}">
                        {{item['skuNumber']}}
                    </div>
                    </div>
                    <txp-badge
                        *ngIf="isHeroProductGroup(item)"
                        [type]="badgeType.INFO">
                        {{'catalog.combo.hero' | translate}}
                    </txp-badge>
                    <a class="action"
                        *ngIf="!isHeroProductGroup(item)"
                        (click)="handleDelete(item)"
                        data-qa-label="DeleteButton"
                        [attr.title]="'form.button.remove' | translate">
                        <i class="tce-icon-trash"></i>
                    </a>
                </div>
            </div>

        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <txp-button [style]="buttonStyle.SECONDARY"
                data-qa-label="CancelButton"
                (click)="handleCancel()">{{ 'form.button.cancel' | translate }}</txp-button>
    <txp-button [style]="buttonStyle.PRIMARY"
                data-qa-label="DoneButton"
                (click)="handleDone()">{{ 'form.button.done' | translate }}</txp-button>
</mat-dialog-actions>
